/**
 * Feature flags convention: go/frontend-feature-flags
 */

import memoizeOne from 'memoize-one';

// This function used to return LD feature flags, but LD is no longer supported. Please clean up or make compatible with statsig.
export const getDashboardFeatureFlags = memoizeOne(() => ({}));
